import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createRunPreliminaryCheckThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplyProcessActionTypes.RunPreliminaryCheck, async () => {
    const response = await api.runPreliminaryCheck();

    return response;
  });
